export const SYSTEM_STROKE_WIDTH = 0.2;
export const WIZARD_STROKE_WIDTH = 0.1;
export const systemStrokeWidthProps = { strokeWidth: SYSTEM_STROKE_WIDTH };
export const wizardStrokeWidthProps = { strokeWidth: WIZARD_STROKE_WIDTH };
